import React from "react";
import { Navigate } from "react-router-dom";
import { isAdminLogin, isLogin } from "./services/auth";
import { ReactElement } from "react";

interface RequireAuthProps {
  children: ReactElement;
  redirectTo?: string;
  isAdmin?: boolean;
}

const RequireAuth: React.FC<RequireAuthProps> = ({
  children,
  redirectTo,
  isAdmin
}): ReactElement | null => {
  if (isAdmin) {
    return (isLogin() && isAdminLogin()) ? children : <Navigate to={redirectTo || '/dashboard'} />;
  } else {
    return isLogin() ? children : <Navigate to={redirectTo || '/'} />;
  }
};

export default RequireAuth;
